import { FC, PropsWithChildren, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  className?: string;
  el?: string;
  after?: boolean;
};

const Portal: FC<PropsWithChildren<Props>> = ({
  children,
  after = false,
  className = 'root-portal',
  el = 'div',
}) => {
  const [container] = useState(() => {
    // This will be executed only on the initial render
    // https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    return document.createElement(el);
  });

  useEffect(() => {
    container.classList.add(className);
    after ? document.body.appendChild(container) : document.body.prepend(container);
    return () => {
      document.body.removeChild(container);
    };
  }, []);

  return ReactDOM.createPortal(children, container);
};

export default Portal;
